import React, { useState } from "react";
import { useSelector } from "react-redux";
import "./style.css";

// setTableName, setNote
const TableSection = (props) => {
  const labels = useSelector( ( state ) => state.labels );
  const [tableName, setTableName] = useState(props.providedTableName);
  const [note, setNote] = useState("");

  /**
   * Handles the change event for updating the table name.
   *
   * @param {Event} event - The change event.
   */
  const handleOnChange = (event) => {
    const inputValue = event.target.value;
    setTableName(inputValue);
    props.setTableName(inputValue);
  };

  /**
   * Handles the change event for updating the note associated with the table.
   *
   * @param {Event} event - The change event.
   */
  function handleNoteChange(event) {
    const inputValue = event.target.value;
    setNote(inputValue);
    props.setNote(inputValue);
  }

  return (
    <div className="new-project-container">
      <div className="new-project-container-wrapper-table">
        <span className="subtitle-small">{props.newProjectTitle}</span>
        <div className="new-project-container-name">
          <label
            htmlFor="table-section-name"
            className="body-small-greyscale new-project-container-name-text"
          >
            { labels.tableName }
          </label>
          <input
            type="text"
            id="table-section-name"
            className="new-project-container-name-input"
            value={tableName}
            onChange={handleOnChange}
          />
        </div>
        <div className="new-project-container-description">
          <label
            htmlFor="table-section-id"
            className="body-small-greyscale new-project-container-description-text"
          >
            { labels.note }
          </label>
          <input
            type="text"
            id="table-section-id"
            value={note}
            className="new-project-container-description-input"
            onChange={handleNoteChange}
          />
        </div>
      </div>
    </div>
  );
};

export default TableSection;
